module.exports = __webpack_public_path__ + "Lato-Regular.baec1062903ba290a634.ttf";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Regular.ttf
// module id = ../../../../../src/assets/fonts/Lato-Regular.ttf
// module chunks = styles